module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-alert', {
    staticClass: "margin-b-20",
    attrs: {
      "title": _vm.$t('static.products.create.success'),
      "type": "success"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "flex-direction": "column"
    }
  }, [_c('el-button', {
    staticClass: "margin-b-20",
    staticStyle: {
      "width": "380px"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v(_vm._s(_vm.$t('static.products.create.options.edit')))]), _vm._v(" "), _c('el-button', {
    staticClass: "margin-b-20",
    staticStyle: {
      "width": "380px"
    },
    on: {
      "click": _vm.addMore
    }
  }, [_vm._v(_vm._s(_vm.$t('static.products.create.options.addMore')))]), _vm._v(" "), _c('el-button', {
    staticClass: "margin-b-20",
    staticStyle: {
      "width": "380px"
    },
    on: {
      "click": _vm.gotoIndex
    }
  }, [_vm._v(_vm._s(_vm.$t('static.products.create.options.gotoIndex')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b43a2aa","hasScoped":false}!./src/app/components/productCreatePopup/productCreatePopup.html
// module id = 3049
// module chunks = 1